import { render } from "./Crud.vue?vue&type=template&id=459be1ce&scoped=true"
import script from "./Crud.vue?vue&type=script&lang=js"
export * from "./Crud.vue?vue&type=script&lang=js"

import "./Crud.vue?vue&type=style&index=0&id=459be1ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459be1ce"]])

export default __exports__